import { FC } from "react";
import { Icon, Stack, Text } from "@chakra-ui/react";

import { CalendarIcon } from "../../../../icons";

export const SbpTransferPageScheduleEmpty: FC = () => {
  return (
    <Stack spacing="6px" alignItems="center">
      <Icon as={CalendarIcon} boxSize="24px" />

      <Text w="200px" mt="-1px" fontSize="12.5px" lineHeight="14px" textAlign="center">
        Введите сумму и выберите срок для формирования графика
      </Text>
    </Stack>
  );
};
